import { IconButton } from "@material-ui/core";
import ListIcon from '@material-ui/icons/List';
import { Dialog } from "@mui/material";
import { useState } from "react";
import AssetDwellTable from "./AssetDwellTable";

export const AssetDwellListDialog = ({  data }) => {
    const [showList, setShowList] = useState(false);
    return (
        <>
            <IconButton size="small" onClick={() => setShowList(true)}><ListIcon /></IconButton>
            <Dialog maxWidth='xl' fullWidth open={showList} onClose={() => setShowList(false)}>
                <AssetDwellTable assetData={data} title={"Asset Dwell Report"} />
            </Dialog>
        </>
    )
}
